// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"containerStyles-module--wrapper--2Jip1","thin":"containerStyles-module--thin--271hh"};